const colors = [
    '#539198',
    '#c04e4e',
    '#c79f34',
    '#656d37',
    '#a1bdbe',
    '#ccc5c5',
    '#af3429',
];

const getColor = (level) => {
    const colorIndex = (level - 1) % colors.length;
    let color
    if (level == 0) {
        color = '#da856c'
    } else {
        color = colors[colorIndex];
    }
    return color;
}

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: (_, record) => (<p className='font-semibold' style={{ color: getColor(record?.level) }} >{record?.name}</p>),
    },
    {
        title: 'Level',
        dataIndex: 'level',
    },
    {
        title: 'Count',
        dataIndex: 'count',
    },
    {
        title: 'Email',
        dataIndex: 'email',
    },
    {
        title: 'Mobile No',
        dataIndex: 'mobileNo',
    },
];

export default columns;